import Pagination from "react-js-pagination";

const PaginationComponent = ({ currentPage, PageChangeHandler, totalPages, pageSize = 10 }) => {
  const totalData = totalPages * pageSize;
  return (
    <>
      {totalPages > 1 && 
      <Pagination
        activePage={currentPage}
        itemsCountPerPage={pageSize}
        totalItemsCount={totalData}
        pageRangeDisplayed={3}
        onChange={(page) => PageChangeHandler(page)}
      />}
    </>
  )
}
export default PaginationComponent;
